import React from 'react';
import './render-tabs.scss';
import { APP_TYPE, getAppType, useAppSelector } from '@zonofi/zono-money-store';

export interface Tabs {
  title: string;
  icon?: React.ReactNode;
}

interface RenderTabsProps {
  tabs: Tabs[];
  selectedTab: number;
  onTabSelected: (tabIndex: number) => void;
}

export const RenderTabs: React.FC<RenderTabsProps> = ({
  tabs,
  selectedTab,
  onTabSelected,
}) => {
  const appType = useAppSelector(getAppType);

  return (
    <div
      className={`render-tabs font-regular ${appType === APP_TYPE.FIELDS_OPS ? 'field-ops-bg' : 'seller-hub-bg'}`}
    >
      {tabs?.map((tab, idx) => (
        <div
          className={`render-tabs-tab ${selectedTab === idx ? 'active font-semibold' : ''}`}
          onClick={() => onTabSelected(idx)}
          key={idx}
        >
          {tab?.icon}
          <span>{tab.title}</span>
        </div>
      ))}
    </div>
  );
};
